module.exports = __webpack_public_path__ + "files/2d60b571f53d68b5db9951655c2fe868.png";